import * as React from "react";

import "./history-panel.scss";

import {cs}          from "@Common/react/chain-services";
import {UseState}    from "@Common/react/use-state";
import {DataTableD1} from "@Common/ui-components/heavy/common/design2/data-table/data-table-d1";
import {PageList}    from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";

import {formatDate} from "../../../../../../wallet/vouchers-route/details-modal/common/format-date";

export const HistoryPanel = ({history, next}) => cs(
    () => next({
        renderContent: () => cs(
            ({}) => (
                <div className="history-panel history-panel-5mh">
                    {DataTableD1({
                        pageSize: 10,
                        rows: history?.history?.map((u) => ({
                            columns: [
                                {
                                    render: () => formatDate(u.dateCreated),
                                    sortValue: () => new Date(u.dateCreated).getTime(),
                                    domAttrs: {
                                        "xd-qa-type": "label",
                                        "xd-qa-name": "DATE",
                                    },
                                },
                                {
                                    render: () => <>
                                        <div className="systemComments" xd-qa-type="text" xd-qa-name={u.systemComments}>
                                            {u.systemComments}
                                        </div>

                                        {u.comments ? (
                                            <div className="comments">
                                                {u.comments.length > 14 + 3 ? cs(
                                                    ["expanded", (_, next) => UseState({next})],
                                                    ({expanded}) => !expanded.value ? <>
                                                        <div className="text" xd-qa-type="text" xd-qa-name={u.comments.substring(0, 14) + "..."}>
                                                            {u.comments.substring(0, 14) + "..."}
                                                        </div>
                                                        <a {...{
                                                            className: "expand",
                                                            onClick: () => expanded.onChange(true)
                                                        }}
                                                            xd-qa-type="link"
                                                            xd-qa-name="Expand"
                                                        >[+]</a>
                                                    </> : <>
                                                        <div className="text" xd-qa-type="text" xd-qa-name={u.comments}>
                                                            {u.comments}
                                                        </div>
                                                        <a {...{
                                                            className: "expand",
                                                            onClick: () => expanded.onChange(false)
                                                        }}
                                                            xd-qa-type="link"
                                                            xd-qa-name="Collapse"
                                                        >[-]</a>
                                                    </>
                                                ) : (
                                                    <div className="text" xd-qa-type="text" xd-qa-name={u.comments}>
                                                        {u.comments}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="no-comments" xd-qa-type="label" xd-qa-name="No Comments">
                                                No comments
                                            </div>
                                        )}
                                    </>,
                                    domAttrs: {
                                        "xd-qa-type": "label",
                                        "xd-qa-name": "ACTIVITY",
                                    },
                                },
                            ],
                            xdQaName: u.idPrimary,
                        })),
                        columns,

                        getFooter: ({colCount, pagination}) => pagination.active && ({
                            columns: [{
                                colSpan: colCount,
                                render: () => (
                                    PageList({
                                        ...pagination,
                                    })
                                )
                            }],
                        }),
                    })}


                    {/* <div className="actions">
                        <button {...{

                        }}>
                            DOWNLOAD VOUCHER REPORT
                        </button>
                    </div> */}
                </div>
            ),
        )
    }),
);

const columns = [
    {
        label: "DATE",
        className: "date",
        sortable: {
            defaultDirection: "desc",
        },
        width: "20%",
    },
    {
        label: "ACTIVITY",
        className: "activity",
        width: "80%",
    },
];

